import { compose, withHandlers, withProps } from 'recompose';
import { withTranslation } from 'react-i18next';

import VenueSuggestionItem from 'components/AddressModal/components/VenueSuggestionItem/component';

const enhance = compose(
  withTranslation('StopAddress'),
  withHandlers({
    handleClick:
      ({ value, onClick }) =>
      () => {
        onClick({ value });
      },
  }),
  withProps(({ value }) => ({
    address: value,
  }))
);

export default enhance(VenueSuggestionItem);
